export class CartInfo {
    Id:number;
    JobsPrice: string;
    TotalAmountBeforeTaxes: string;
    Vat: string;    
    TotalAmountAfterTaxes: string;
    
    Payment: string;
    Shipment: string;
    Voucher: string;
    VoucherID: string;
    Imballo: string;

    Tax: string;
    Currency: string;
    Products: CartProductModel[];

    CurrentAddress: CartAddressModel;
    Addresses: Array<CartAddressModel>;
    Payments: Array<CartPaymentModel>;
    Shipments: Array<CartShipmentModel>;
}
export class CartProductModel {
    Id: number;
    Delivery: string;
    Name: string;
    Quantity: number;

    TotalPriceAfterTax: string;
    TotalVat: string;
    TotalPriceBeforeTax: string;
    Description: string;
    Image: string;
    JobName: string;
    isCanvasEdited: boolean;
    CanvasStateId: string;
    TipoTrasporto: string;
    DeliveryTime: string;
}
export class CartAddressModel {
    Id: number;
    Recipient: string;
    Address: string;
    City: string;
    Province: string;
    ZipCode: string;
    Phone: string;
    Mobile: string;
    Default: boolean;
    Name: string;
    CustomerID: string;
    Language: string;
    AddressNumber: string;
}
export class CartPaymentModel {
    Id: number;
    Name: string;
    Amount: number;
    Description: string;
    Selected: boolean;
    OrderSort:number;
}
export class CartShipmentModel {
    Id: number;
    Name: string;
    Amount: number;
    Description: string;
    Selected: boolean;
    TipoTrasporto: string;
    UnitaId: number = 0;
    RitiroDestinatario: string;
    RitiroIndirizzo: string;
    RitiroCap: string;
    RitiroProvincia: string;
    RitiroCitta: string;
    RitiroTelefono: string;
    RitiroCellulare: string;
    Default: boolean;
    DefaultShipment: boolean;
    Sort: number;
    Latitudine: string;
    Longitudine: string;
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/models/core/cart.ts